import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";

const TotalSection = ({
    items,
    shipping,
    setShipping,
    customerNote,
    setCustomerNote,
    advance_payment,
    setAdvancePayment,
    setTotals
}) => {
    const [subtotal, setSubtotal] = useState(0);
    const discountPercent = (items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0);
    const discount_amount = (discountPercent * subtotal / 100);
    const taxPercent = (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0);
    const tax = (subtotal - discount_amount) * taxPercent / 100;
    const grand_total = subtotal - discount_amount + tax + parseFloat(shipping || 0);
    const pending = subtotal - discount_amount - (parseFloat(advance_payment) || 0) + tax + parseFloat(shipping || 0);
    const url = process.env.REACT_APP_LINK
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const fetchDataProfile = async () => {
        const strippedNote = customerNote?.replace(/<\/?[^>]+(>|$)/g, "").trim();

        if (strippedNote) {
            console.log("✅ Skipping overwrite from profileData");
            return;
        }

        try {
            const profileRes = await fetch(`${url}/auth/singleuser/${isLoggedIn.user_id}`);
            const res = await profileRes.json();
            const profileData = res;
            console.log("⚠️ profileData.custom_note being used:", profileData.custom_note);
            setCustomerNote(profileData.custom_note || "");
        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        const calculatedSubtotal = items.reduce((acc, row) => {
            const quantity = parseFloat(row.quantity) || 0;
            const rate = parseFloat(row.rate) || 0;
            return acc + quantity * rate;
        }, 0);
        setSubtotal(calculatedSubtotal);
    }, [items]);

    useEffect(() => {
        fetchDataProfile();
    }, [])

    useEffect(() => {
        setTotals({
            subtotal,
            discount_amount,
            advance_payment,
            pending,
            tax,
            shipping,
            grand_total
        });
    }, [subtotal, discount_amount, advance_payment, pending, tax, shipping, grand_total, setTotals]);


    return (
        <>
            <div className="invoice-customer-summary">
                <div className="customer-note-summary">
                    <div className="oms-form-group">
                        <label htmlFor='customer-note' className="oms-form-label">
                            Customer note
                        </label>
                        <ReactQuill
                            theme="snow"
                            value={customerNote}
                            onChange={(e) =>
                                setCustomerNote(e)
                            }
                            style={{ backgroundColor: "#fefffc" }}
                            placeholder="Note for customer"
                            key={customerNote ? "note-loaded" : "note-empty"}
                        />
                        <p className="customer-note-p">
                            This will appear on the invoice.
                        </p>
                    </div>
                </div>
                <div className="invoice-summary">
                    <div className="invoice-summary-content">
                        {/* Subtotal Section */}
                        <div className="invoice-row">
                            <p className="invoice-label">Subtotal</p>
                            <strong>
                                <p className="invoice-value">₹{subtotal.toFixed(2)}</p>
                            </strong>
                        </div>

                        <div className="invoice-row">
                            <p className="invoice-label">Discount Amount</p>
                            <strong>
                                <p className="invoice-value">
                                    ₹{(
                                        (items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0)
                                        * subtotal / 100
                                    ).toFixed(2)}
                                </p>
                            </strong>
                        </div>

                        <div className="invoice-row">
                            <div className="invoice-shipping">
                                <p className="invoice-label">Advance Payment</p>
                                <input
                                    type="number"
                                    name="advance_payment"
                                    placeholder="Enter Advance Payment"
                                    className="invoice-input"
                                    value={advance_payment === 0 ? "" : advance_payment}

                                    onChange={(e) => setAdvancePayment(parseFloat(e.target.value) || 0)}
                                />
                            </div>
                            <p className="invoice-value">₹{parseFloat(advance_payment || 0).toFixed(2)}</p>
                        </div>


                        <div className="invoice-row">
                            <p className="invoice-label">Tax</p>
                            <strong>
                                <p className="invoice-value">
                                    ₹{(
                                        (
                                            subtotal -
                                            ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100)
                                        ) *
                                        (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0) / 100
                                    ).toFixed(2)}
                                </p>
                            </strong>
                        </div>


                        {/* Shipping Section */}
                        <div className="invoice-row">
                            <div className="invoice-shipping">
                                <p className="invoice-label">Service Fees/Shipping</p>
                                <input
                                    type="number"
                                    name="shipping"
                                    placeholder="Enter service fees/shipping"
                                    className="invoice-input"
                                    value={shipping === 0 ? "" : shipping}

                                    onChange={(e) =>
                                        setShipping(parseFloat(e.target.value) || 0)
                                    }
                                />
                            </div>
                            <p className="invoice-value">₹{parseFloat(shipping || 0).toFixed(2)}</p>
                        </div>


                        <div className="invoice-row">
                            <p className="invoice-label">Pending</p>
                            <strong>
                                <p className="invoice-value">
                                    ₹{(
                                        subtotal -
                                        ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100) -
                                        (parseFloat(advance_payment) || 0) +
                                        (
                                            (subtotal -
                                                ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100)) *
                                            (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0) / 100
                                        ) +
                                        (parseFloat(shipping || 0))
                                    ).toFixed(2)}
                                </p>
                            </strong>
                        </div>


                        {/* Total Section */}
                        <div className="invoice-row invoice-total">
                            <p className="invoice-label">Grand Total (₹)</p>
                            <p className="invoice-value invoice-grand-total">
                                ₹{(
                                    subtotal -
                                    ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100) +
                                    ((subtotal -
                                        ((items.reduce((acc, row) => acc + (parseFloat(row.discount) || 0), 0) / items.length || 0) * subtotal / 100)) *
                                        (items.reduce((acc, row) => acc + (parseFloat(row.tax) || 0), 0) / items.length || 0) / 100) +
                                    (parseFloat(shipping) || 0)
                                ).toFixed(2)}
                            </p>
                        </div>


                    </div>
                </div>
            </div>
        </>
    );
};

export default TotalSection;
